import AxiosClient from "../../../services/axios.services";

class LevelServices {
  getLevelEmployee = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_empleado_nivel/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getLevelEmployeeById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_empleado_nivel/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveLevelEmployee = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_empleado_nivel/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editLevelEmployee = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_empleado_nivel/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteLevelEmployee = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_empleado_nivel/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new LevelServices();
